export default "__VITE_ASSET__fMgBJsJi__"